import {
    BasePostExtendQuoteParams,
    ExtendQuoteByCatalogIdParams,
    ExtendQuoteByInvoiceIdParams,
    PostExtendQuoteResponse,
} from './extendQuote.types';
import { handleResponseV2, makePost } from '@/redux/api/helpers';

export const postExtendInvoiceQuote = ({
    authToken,
    deployment,
    invoiceId,
}: BasePostExtendQuoteParams & ExtendQuoteByInvoiceIdParams) =>
    new Promise<PostExtendQuoteResponse>((resolve, reject) => {
        const request = makePost({
            apiPath: `v1/marketplace/LA/invoice/${invoiceId}/extend-shipping-offer`,
            authToken,
            deployment,
            path: '<SHIPPING-API>',
        });

        request.end((err, response) => handleResponseV2({ err, reject, resolve, response }));
    });

export const postExtendCatalogQuote = ({
    authToken,
    catalogId,
    deployment,
}: BasePostExtendQuoteParams & ExtendQuoteByCatalogIdParams) =>
    new Promise<PostExtendQuoteResponse>((resolve, reject) => {
        const request = makePost({
            apiPath: `v1/marketplace/LA/catalog/${catalogId}/extend-shipping-offer`,
            authToken,
            deployment,
            path: '<SHIPPING-API>',
        });

        request.end((err, response) => handleResponseV2({ err, reject, resolve, response }));
    });
